<div class="container d-flex align-items-center">
    <input #myInput (keyup)="takeInput($event)" name="searchBox" type="search" class="form-control me-2"
           placeholder="Caută un produs" aria-label="Search">
    <button type="submit" class="btn btn-primary d-flex align-items-center" [routerLink]="['produse','search-'.concat(inputValue)]" (click)="reset()"><i class="fa fa-search"></i> Caută</button>
</div>